import React, { useState } from "react";

export default function SmarterWork() {
  const [activeCard, setActiveCard] = useState("brands");

  return (
    <div className="px-4 py-12 max-w-7xl mx-auto">
      <div className="text-center mb-10">
        <button className="text-sm px-3 py-1 bg-gray-100 rounded-full mb-2">
          Why choose us
        </button>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
          A smarter way to work
        </h1>
      </div>

      <div className="flex justify-center space-x-6 mb-8">
        <button
          onClick={() => setActiveCard("brands")}
          className={`font-semibold border-b-2 ${
            activeCard === "brands"
              ? "text-black border-black"
              : "text-gray-500 border-transparent"
          }`}
        >
          For Brands
        </button>
        <button
          onClick={() => setActiveCard("vendor")}
          className={`font-semibold border-b-2 ${
            activeCard === "vendor"
              ? "text-black border-black"
              : "text-gray-500 border-transparent"
          }`}
        >
          For Vendor Partners
        </button>
        <button
          onClick={() => setActiveCard("install")}
          className={`font-semibold border-b-2 ${
            activeCard === "install"
              ? "text-black border-black"
              : "text-gray-500 border-transparent"
          }`}
        >
          For Installation Partners
        </button>
      </div>

      <div className="flex gap-4 transition-all duration-500">
        <div
          className={`relative rounded-xl overflow-hidden shadow-md transform transition-all duration-500 ${
            activeCard === "brands" ? "flex-[2]" : "flex-[1]"
          }`}
        >
          <img
            src="/assests/images/LandingPage/work-section.jpg"
            alt="For Brands"
            className="w-full h-80 object-cover"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-30 text-white p-4">
            <h2 className="text-lg font-semibold">For Brands</h2>
            <p className="text-sm mt-2 text-white">
              Seamlessly work with clients and team members in real-time to
              bring your design visions to life.
            </p>
          </div>
        </div>
        <div
          className={`relative rounded-xl overflow-hidden shadow-md transform transition-all duration-500 ${
            activeCard === "vendor" ? "flex-[2]" : "flex-[1]"
          }`}
        >
          <img
            src="/assests/images/LandingPage/work-section.jpg"
            alt="For Brands"
            className="w-full h-80 object-cover"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-30 text-white p-4">
            <h2 className="text-lg font-semibold">For Brands</h2>
            <p className="text-sm mt-2 text-white">
              Seamlessly work with clients and team members in real-time to
              bring your design visions to life.
            </p>
          </div>
        </div>

        <div
          className={`relative rounded-xl overflow-hidden shadow-md transform transition-all duration-500 ${
            activeCard === "install" ? "flex-[2]" : "flex-[1]"
          }`}
        >
          <img
            src="/assests/images/LandingPage/work-section.jpg"
            alt="For Brands"
            className="w-full h-80 object-cover"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-30 text-white p-4">
            <h2 className="text-lg font-semibold">For Brands</h2>
            <p className="text-sm mt-2 text-white">
              Seamlessly work with clients and team members in real-time to
              bring your design visions to life.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
